/// <amd-module name="Repos/Views/Settings/Repositories-Policies/Components/BranchPolicies" />
import React = require("react");
import { IPolicy } from "Repos/Views/Settings/Repositories-Policies/Contracts/Contracts";
import * as Resources from "Repos/Views/Settings/Repositories-Policies/Resources";
import { VssComponent } from "VSS/Platform/Layout";
import { Card } from "VSSUI/Card";
import { Observer } from "VSSUI/Observer";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";
import { IPoliciesViewService } from "../Services/PoliciesViewService";
import { AutomaticReviewerPolicies } from "./AutomaticReviewerPolicies";
import { BuildPolicies } from "./BuildPolicies";
import { PolicyToggle } from "./PolicyToggle";
import { StatusPolicies } from "./StatusPolicies";

interface IBrnachPoliciesProps {
    goToProject: () => void;
    goToRef?: (ref: string, repositoryId?: string) => void;
}

export class BranchPolicies extends VssComponent<IBrnachPoliciesProps> {
    public render = (): JSX.Element => {
        const policyService = this.context.pageContext.getService<IPoliciesViewService>("PoliciesViewService");

        return (
            <div className="flex-column rhythm-vertical-20">
                <Observer ready={policyService.isReady()} toggles={policyService.getTogglePolicies()}>
                    {({ ready, toggles }: { ready: boolean; toggles: IPolicy[] }) => {
                        return (
                            <>
                                <Card
                                    className="flex-grow policies"
                                    titleProps={{ text: Resources.BranchPolicies }}
                                    contentProps={{ contentPadding: false }}
                                    headerDescriptionProps={{ text: Resources.RequiredBranchPolicyNote }}
                                >
                                    {ready ? (
                                        <div className="flex-column flex-grow">
                                            {toggles.map(policy => {
                                                return (
                                                    <PolicyToggle
                                                        key={policy.type}
                                                        policy={policy}
                                                        goToProject={this.props.goToProject}
                                                        goToRef={this.goToRef}
                                                    />
                                                );
                                            })}
                                        </div>
                                    ) : (
                                        <div className="flex-grow justify-center flex-column padding-16">
                                            <Spinner size={SpinnerSize.large} />
                                        </div>
                                    )}
                                </Card>

                                <BuildPolicies policies={policyService.getBuildPolicies()} isEditable={policyService.isEditable()} ready={ready} />

                                <StatusPolicies policies={policyService.getStatusPolicies()} isEditable={policyService.isEditable()} ready={ready} />

                                <AutomaticReviewerPolicies
                                    policies={policyService.getReviewerPolicies()}
                                    isEditable={policyService.isEditable()}
                                    ready={ready}
                                />

                                {/* Empty room at the bottom so scroll doesn't happen when filters are applied,
                                which may remove items from view and thus make the page shorter.
                                Scrolling would close the dropdown, with user input going nowhere or even worse,
                                causing unexpected side effects like invoking navigation shortcuts. */}
                                <div style={{ height: Math.max(50, window.innerHeight - 200) }} />
                            </>
                        );
                    }}
                </Observer>
            </div>
        );
    };

    private goToRef = (ref: string, repositoryId?: string) => {
        if (this.props.goToRef) {
            this.props.goToRef(ref, repositoryId);
        }
    };
}
